import axios from 'axios'

export class ApiError extends Error {
  readonly status?: number
  readonly code?: string
  readonly details?: unknown

  constructor(message: string, options?: { status?: number; code?: string; details?: unknown; cause?: unknown }) {
    super(message)
    this.name = 'ApiError'
    this.status = options?.status
    this.code = options?.code
    this.details = options?.details

    if (options?.cause !== undefined) {
      ;(this as Error & { cause?: unknown }).cause = options.cause
    }
  }
}

export const toApiError = (error: unknown): ApiError => {
  if (error instanceof ApiError) {
    return error
  }

  if (axios.isAxiosError(error)) {
    const responseData = error.response?.data as { message?: string; code?: string } | undefined

    return new ApiError(responseData?.message || error.message || 'Request failed', {
      status: error.response?.status,
      code: responseData?.code,
      details: error.response?.data,
      cause: error,
    })
  }

  if (error instanceof Error) {
    return new ApiError(error.message, { cause: error })
  }

  return new ApiError('Unknown API error', { details: error })
}
